/** @ngInject */
export default function UsersController(userService, UserModel, UtilService) {
  var vm = this;
  vm.isLoading = false;
  vm.users = [];
  vm.availableRoles = [];
  vm.newUser = new UserModel();

  vm.init = init;
  vm.getAvailableUserRoles = getAvailableUserRoles;
  vm.toggleUserRole = toggleUserRole;

  init();

  function init() {
    getAvailableUserRoles();
  }

  function getAvailableUserRoles() {
    userService.getAvailableUserRoles().then(function(res) {
      vm.availableRoles = res.data;
      getUsers();
    });
  }

    function getUsers() {
      userService.getUsers().then(function(res) {
        if (res.data) {
          vm.users = res.data.users;
        }
      });
    }

  function toggleUserRole(role) {
    UtilService.toggleElementFromArray(vm.newUser.roles, role);
  }
}



// WEBPACK FOOTER //
// ./src/app/users/users.controller.js